import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7 1.433A1.333 1.333 0 0 1 8.206.298l5.942.835c.73.102 1.237.777 1.135 1.506L14.263 9.9a1.333 1.333 0 0 1-1.507 1.135l-1.048-.148-.377-2.746 1.796.253.835-5.942-5.941-.835-.193 1.37-1.376.21.248-1.765Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.148 5.133a1.333 1.333 0 0 0-1.135 1.506l1.02 7.262c.103.73.777 1.237 1.507 1.135l5.94-.836a1.333 1.333 0 0 0 1.135-1.506l-1.02-7.262A1.333 1.333 0 0 0 8.09 4.298l-5.942.835Zm1.124 3.208a.667.667 0 1 0-.185-1.32.667.667 0 0 0 .185 1.32Zm5.374-.082.557 3.96-5.942.836 1.894-2.69 1.281 1.032 2.21-3.138Z"
  })));
});

/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { ImagesEmpty16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */
export var ImagesEmpty16 = createIcon(IconComponent);